import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const receiveTypeListReducer = (state = [], action) => {
  const actionName = serverApis.getReceiveTypeList.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return action.json.types;

    case getResetAction(actionName):
      return [];
    default:
      return state;
  }
};
